<script lang="ts" setup>
definePageMeta({
  validate: validateAndCacheEntity('location', fetchLocationBySlug),
  authType: 'public',
})

const slugId = computed(() => useSlugId().value._unsafeUnwrap())
const { data: location, suspense } = useLocationBySlug(slugId)
onServerPrefetch(async () => {
  await suspense()
})

useSeoMeta({
  title: computed(() => location.value?.name ?? ''),
})
</script>

<template>
  <div v-if="location">
    <AlLocationHeader :location="location" />

    <AlCmsPageSection
      v-for="section of location.cms_page_section"
      :key="section.id"
      :section="section"
    />

    <AlLocationPageShowcase :location-slug-id="slugId" />
  </div>
  <div v-else />
</template>
